<template>
  <div class="row mt-4 mb-4">
    <div class="col-12 col-md-8 text-primary">
      <h5 v-html="title"></h5>
    </div>

    <div class="col-12 col-md-4" v-if="!disabled">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
          type="button"
          class="btn btn-primary btn-with-shadow"
          data-toggle="modal"
          @click="openAddEditModal"
        >
          Añadir
        </button>
      </div>
    </div>

    <p class="col-12 mt-4" v-html="subtitle"></p>

    <div class="col-12 mt-4">
      <app-table :id="tableId" :options="options" @action="getListAction" />

      <form-v2-csia-location-acc-bodies-modal
        v-if="isAddEditModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
      />

      <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
      />
    </div>

    <p class="col-12 mt-4" v-html="footer"></p>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { tableHelpers } from "./tableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [tableHelpers],
  props: {
    disabled: Boolean,
    title: String,
    subtitle: String,
    footer: String,
  },
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      rowData: {},
      options: {
        url: `accreditations/accBodies/index?accAppId=${this.$store.state.accreditation.id}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "acc-bodies-modal",
            modalId: "add-edit-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "delete",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      tableId: "form-v2-csia-location-acc-bodies-index",
    };
  },
  created() {
    this.options.columns = [
      ...this.tableColumns,
      this.disabled ? [] : this.actionObj,
    ];
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `accreditations/accBodies/show/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `accreditations/accBodies/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
};
</script>
